import { IApiClient } from "@common/network/interfaces";
import { ApiClient } from "@network/client";
import { getConfig } from "@config/index";

import {
  deleteThemeData,
  getAllThemeData,
  getThemeData,
  saveFormData,
} from "../apis/urls";

const ENDPOINTS = {
  saveFormData: () => saveFormData,
  getAllThemeData: () => getAllThemeData,
  getThemeById: (themeId) => `${getThemeData}${themeId}`,
  deleteThemeData: () => deleteThemeData,
};

class ThemeRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }
  public saveThemeData = async (themeData) => {
    const payload = themeData;
    const result = await this.apiClient.post(
      ENDPOINTS.saveFormData(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL, //hardcoded value have to make Config
      }
    );
    return result.data;
  };
  public getAllThemeData = async () => {
    const result = await this.apiClient.get(
      ENDPOINTS.getAllThemeData(),
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL, //hardcoded value have to make Config
      }
    );
    return result.data;
  };
  public getThemeById = async (themeId) => {
    const result = await this.apiClient.get(
      ENDPOINTS.getThemeById(themeId),
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL, //hardcoded value have to make Config
        disableEnvelope: true,
      }
    );
    return result.data;
  };
  public deleteThemeData = async (themeId) => {
    const result = await this.apiClient.delete(
      ENDPOINTS.deleteThemeData(),
      {},
      { themeId },
      {
        baseURL: getConfig().APP_BE_BASE_URL, //hardcoded value have to make Config
        disableEnvelope: true,
      }
    );
    return result.data;
  };
}

const themeRepository = new ThemeRepository(ApiClient);

export { themeRepository as ThemeRepository };
